var map = {
	"./cat_1.png": 8023,
	"./cat_3.png": 6805,
	"./cat_5.png": 2899,
	"./cat_7.png": 1121,
	"./cat_9.png": 63,
	"./cat_activity_11.png": 3914,
	"./cat_activity_12.png": 7729,
	"./cat_activity_13.png": 9864,
	"./cat_activity_14.png": 5031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2369;